module.exports = "fonts/Twemoji_Mozilla/TwemojiMozilla-colr.78a2a9b.woff2";